module.exports = __webpack_public_path__ + "static/media/CabinetDoor1_Before.b3a64c54.jpg";